module.exports = __webpack_public_path__ + "static/video5-0abe3f99a57725b06bfd9e4c18f57795.mp4";